import React from 'react';
import { Modal, Button } from 'react-bootstrap';

import { useStateValue } from '../context/state.jsx';
import { closeAlert } from '../context/alert.js';

const Alert = () => {
	const [{ alert }, dispatch] = useStateValue();
	if (!alert) {
		return null;
	}
	const choices = alert.choices.map((choice, index) => {
		return (
			<Button
				key={index}
				bsStyle={choice.bsStyle || 'default'}
				onClick={() => {
					dispatch(closeAlert());
					if (typeof choice.action === 'function') {
						choice.action();
					}
				}}>
				{choice.text}
			</Button>
		);
	});

	return (
		<Modal
			show
			dialogClassName="swa-dialog alert-modal"
			backdropClassName="swa-overlay-backdrop"
			className="swa-overlay-modal"
			onHide={() => { dispatch(closeAlert()); }}
			centered>
			{alert.title && (
				<Modal.Header closeButton>
					<Modal.Title>{alert.title}</Modal.Title>
				</Modal.Header>
			)}
			<Modal.Body>
				<p>{alert.message}</p>
			</Modal.Body>
			<Modal.Footer>
				{choices}
			</Modal.Footer>
		</Modal>
	);
};

export default Alert;
